import FlagSa from '../Assets/flag/icon-flag-sa.svg';
import FlagEn from '../Assets/flag/icon-flag-en.svg';


export const LanguageData = [
  {
    id: 1,
    flagname: 'English',
    icon: FlagEn,
  },
  {
    id: 5,
    flagname: 'Arabic',
    icon: FlagSa,
  },
];

export const Languages = [
  {
    flagname: 'English (UK)',
    name: 'English',
    icon: FlagEn,
    value: 'en',
  },
  {
    flagname: 'عربي (Arabic)',
    name: 'عربي',
    icon: FlagSa,
    value: 'ar',
  },
];
